import React, { useState } from 'react';
import Text from '../../components/shared/Text/Text';
import Button from '../../components/shared/Button/Button';
import AutocompleteInput from '../../components/shared/AutoCompleteInput/AutoCompleteInput';
import Dropdown from '../../components/shared/DropDown/DropDown';
import Input from '../../components/shared/Input/Input';

const Styleguide: React.FC = () => {
  const [inputValue, setInputValue] = useState('');

  const [selectedAutocompleteinputValue, setSelectedAutocompleteinputValue] =
    useState<string[]>([]);

  const [selectedDropdownValue, setSelectedDropdownValue] =
    useState<string>('option1');
  const options = [
    { label: 'Option 1', value: 'option1' },
    { label: 'Option 2', value: 'option2' },
    { label: 'Option 3', value: 'option3' },
  ];

  return (
    <div style={{ maxWidth: '400px', margin: '40px auto' }}>
      <Text type="h1">Heading 1</Text>
      <Text type="h2">Heading 2</Text>
      <Text type="h3">Heading 3</Text>
      <Text type="subtitle1">subtitle1</Text>
      <Text type="subtitle2">subtitle2</Text>
      <Text type="body1">body1</Text>
      <Text type="body2">body2</Text>
      <Text type="label">label</Text>
      <br />
      <br />
      <br />
      <br />
      <div>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => alert('Clicked!')}
        >
          Primary Button
        </Button>

        <Button
          variant="text"
          color="primary"
          size="small"
          onClick={() => alert('Clicked!')}
        >
          Text Button
        </Button>
      </div>
      <br />
      <br />
      <br />
      <br />

      <div style={{ maxWidth: '400px' }}>
        <div>
          {/* <Input
            label='Name'
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder='Enter your name'
          /> */}
        </div>
        <br />
        <br />
        <br />
        <br />
        {/* <AutocompleteInput
          options={['Option 1', 'Option 2', 'Option 3']}
          label='Select an option'
          value={selectedAutocompleteinputValue}
          onChange={(_e, newValue) =>
            setSelectedAutocompleteinputValue(newValue || [])
          }
          fullWidth
        /> */}
        <br />
        <br />
        <br />
        <br />
        {/* <Dropdown
          label='Select an option'
          value={selectedDropdownValue}
          options={options}
          onChange={(e) => setSelectedDropdownValue(e.target.value as string)}
          fullWidth
        /> */}
      </div>
    </div>
  );
};

export default Styleguide;
